import React from 'react';
import roles from '@utils/rolesConstants';
import { ApplicationsConstants } from '@utils/applicationsConstants';
import {
  ApartmentOutlined,
  ContainerOutlined,
  DatabaseOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  NodeExpandOutlined,
  PieChartOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import LoraPages from '@pages/LoraWan';
import { RouteItemProps } from './types';

const {
  Organization,
  Devices,
  DeviceDetails,
  Dashboards,
  ActionsQueue,
  Forwardings,
  Transfers,
  Contracts,
  ContractDetails,
  Requests,
  RequestDetails,
  Groupings,
  DeviceProfiles,
  Connections,
} = LoraPages();

export const loraWanRoutes: {
  assets: RouteItemProps[];
  operational: RouteItemProps[];
  financial: RouteItemProps[];
  administrative: RouteItemProps[];
} = {
  assets: [
    {
      key: 'Organization',
      path: 'organization',
      role: roles.LORAWAN_VIEW_ORG,
      icon: <ApartmentOutlined />,
      element: <Organization />,
      application: [ApplicationsConstants.LORAWAN],
    },
    {
      key: 'Devices',
      path: 'devices',
      role: roles.LORAWAN_VIEW_DEVICES,
      icon: <DatabaseOutlined />,
      element: <Devices />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
    },
    {
      key: 'DeviceDetails',
      isDetails: true,
      path: 'devices/:devEui',
      role: roles.LORAWAN_VIEW_DEVICES,
      element: <DeviceDetails />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
    },
    {
      key: 'DeviceProfiles',
      path: 'device-profiles',
      role: roles.LORAWAN_VIEW_DEVICE_PROFILES,
      icon: <FileTextOutlined />,
      element: <DeviceProfiles />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
    },
    {
      key: 'Dashboards',
      path: 'dashboards',
      role: roles.LORAWAN_VIEW_DASHBOARDS,
      icon: <PieChartOutlined />,
      element: <Dashboards />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
    },
  ],
  operational: [
    {
      key: 'ActionsQueue',
      path: 'actions-queue',
      role: roles.LORAWAN_VIEW_ACTIONS_QUEUE,
      icon: <NodeExpandOutlined />,
      element: <ActionsQueue />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
    },
    {
      key: 'Forwardings',
      path: 'forwardings',
      role: roles.LORAWAN_VIEW_REFERRALS,
      icon: <TeamOutlined />,
      element: <Forwardings />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
      rootCannotSee: true,
    },
    {
      key: 'Connections',
      path: 'connections',
      role: roles.LORAWAN_VIEW_CONNECTIONS,
      icon: <TeamOutlined />,
      element: <Connections />,
      application: [
        ApplicationsConstants.LORAWAN,
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
      rootCannotSee: true,
    },
    {
      key: 'Transfers',
      path: 'transfers',
      role: roles.LORAWAN_VIEW_TRANSFERS,
      icon: <NodeExpandOutlined />,
      element: <Transfers />,
      application: [
        ApplicationsConstants.MOT_ENTERPRISE,
        ApplicationsConstants.MOT_BUSINESS,
      ],
      isLoraWan: true,
      rootCannotSee: true,
    },
  ],
  financial: [
    {
      key: 'Contracts',
      path: 'contracts',
      role: roles.LORAWAN_VIEW_CONTRACTS,
      icon: <ContainerOutlined />,
      element: <Contracts />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      isLoraWan: true,
      rootCannotSee: true,
    },
    {
      key: 'ContractDetails',
      isDetails: true,
      path: 'contracts/:contractId',
      element: <ContractDetails />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      isLoraWan: true,
      rootCannotSee: true,
    },
    {
      key: 'Requests',
      path: 'requests',
      role: roles.LORAWAN_VIEW_REQUESTS,
      icon: <FileDoneOutlined />,
      element: <Requests />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      isLoraWan: true,
      rootCannotSee: true,
    },
    {
      key: 'RequestDetails',
      isDetails: true,
      path: 'requests/:requestId',
      element: <RequestDetails />,
      application: [ApplicationsConstants.MOT_ENTERPRISE],
      isLoraWan: true,
      rootCannotSee: true,
    },
  ],
  administrative: [
    {
      key: 'Groupings',
      path: 'groupings',
      role: roles.LORAWAN_VIEW_GROUPINGS,
      icon: <TeamOutlined />,
      element: <Groupings />,
      application: [ApplicationsConstants.MOT_BUSINESS],
      rootCannotSee: true,
      isLoraWan: true,
    },
  ],
};
